import React from "react";
import ToddlerSessionForm from "./ToddlerSessionForm";
import {setPageContentMargin} from "../../../Utils";

class ToddlerSession extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            // url: "http://localhost/rfk-rest/rfk-api/api/toddler-sessions",
            url: "https://api.repeatforkids.co.uk/api/toddler-sessions",
            recent: false,
            session_id: "",
            session_name: "",
            session_date: "",
            session_time: "",
            session_end_time: "",
            session_price: "",
            session_reserved: "",
            session_booked: "",
            session_max: "",
            session_image: "",
            session_image_name: "",
            allowed_empty: ['session_image', 'session_image_name', 'session_booked'],
            error: "",
            error_fields: [],
        };
    }

    componentDidMount() {
        setPageContentMargin();
        if (this.props.action === "edit") {
            this.setState({
                recent: this.props.session[0].recent,
                session_id: this.props.session[0].session_id,
                session_name: this.props.session[0].session_name,
                session_date: this.props.session[0].session_date,
                session_time: this.props.session[0].session_time,
                session_end_time: this.props.session[0].session_end_time,
                session_price: this.props.session[0].session_price,
                session_reserved: this.props.session[0].session_reserved,
                session_booked: this.props.session[0].session_booked,
                session_max: this.props.session[0].session_max,
                session_image: this.props.session[0].session_image,
                session_image_name: this.props.session[0].session_image_name,
            });
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        setPageContentMargin();
    }

    handleSessionNameChange = (name) => {
        this.setState({session_name: name.target.value})
    }

    handleSessionImageChange = (image) => {
        let files = image.target.files;
        let fileReader = new FileReader();
        fileReader.readAsDataURL(files[0]);

        fileReader.onload = (img) => {
            this.setState({
                session_image: img.target.result,
            })
        }
    }

    handleSessionDateChange = (date) => {
        this.setState({session_date: date.target.value})
    }

    handleSessionTimeChange = (time) => {
        this.setState({session_time: time.target.value})
    }

    handleSessionEndTimeChange = (time) => {
        this.setState({session_end_time: time.target.value})
    }

    handleSessionPriceChange = (price) => {
        this.setState({session_price: price.target.value})
    }

    handleSessionMaxChange = (max) => {
        this.setState({session_max: max.target.value})
    }

    handleSessionReservedChange = (reserved) => {
        this.setState({session_reserved: reserved.target.value})
    }

    prepareFormData = () => {
        let name = this.state.session_name;
        let date = this.state.session_date;
        let time = this.state.session_time;
        let end_time = this.state.session_end_time;
        let price = this.state.session_price;
        let reserved = this.state.session_reserved;
        let booked = this.state.session_booked;
        let max = this.state.session_max;
        let image = this.state.session_image;
        let image_name = this.state.session_image_name;

        if (image === undefined) {
            image = ""
        }

        let data = {
            'name': name,
            'date': date,
            'time': time,
            'end_time': end_time,
            'price': price,
            'reserved': reserved,
            'booked': booked,
            'max': max,
            'image': image,
            'image_name': image_name,
        }

        return data;
    }

    doSave = (create, saveExit) => {
        if (localStorage.getItem('aawt')) {
            let data = this.prepareFormData()
            let formData = new FormData();

            formData.append('action', (create) ? "new-toddler-session" : "save-toddler-session");
            formData.append('token', localStorage.getItem('aawt'));
            formData.append('session_id', this.state.session_id)
            formData.append('session_name', data.name)
            formData.append('session_date', data.date)
            formData.append('session_time', data.time)
            formData.append('session_end_time', data.end_time)
            formData.append('session_price', data.price)
            formData.append('session_reserved', data.reserved)
            formData.append('session_booked', data.booked)
            formData.append('session_max', data.max)
            formData.append('session_image', data.image)
            formData.append('session_img_name', data.image_name)

            fetch(this.state.url, {
                method: 'POST',
                headers: new Headers(),
                body: formData
            }).then((response) => {
                if (response.status === 200) {
                    return response.json();
                } else {
                    throw Error();
                }
            }).then((data) => {
                if (data.statusCode === 200) {
                    if (create && !saveExit) {
                        this.props.handleNewSessionSave(data.data.session_id);
                    } else {
                        if (saveExit) {
                            this.props.handleSaveExit();
                        }
                    }
                } else {
                    throw Error();
                }
            }).catch((e) => {
                console.log(e)
                console.log(e.toString())
                // todo handle this and other errors/point of failure
                this.setState({
                    error: "Something went wrong. Please try again later."
                });
            });
        } else {
            // alert("handle no auth error");
        }
    }

    checkFormValues = () => {
        let form_error = false
        let error_fields = []
        for (let key in this.state) {
            if (key.includes('session_')) {
                if (this.state[key] === "" && key !== "session_id" && !this.state.allowed_empty.includes(key)) {
                    error_fields.push(key)
                    form_error = true
                    window.scrollTo(0, 0)
                } else {
                    error_fields.filter((field) => {
                        return field !== key
                    });
                }
            }
        }

        if (form_error && error_fields.length !== 0) {
            this.setState({
                error: "Please make sure all required fields are filled.",
                error_fields: error_fields
            })
        }

        return form_error
    }

    handleNewSave = () => {
        let form_error = this.checkFormValues()
        if (!form_error) {
            this.doSave(true, false)
            this.props.handleSaveNotification()
        }
    }

    handleNewSaveExit =() => {
        let form_error = this.checkFormValues()
        if (!form_error) {
            this.doSave(true, true);
        }
    }

    handleSave = (e) => {
        let form_error = this.checkFormValues()
        if (!form_error) {
            this.doSave(false, false)
            this.props.handleSaveNotification()
        }
    }

    handleSaveExit = (e) => {
        let form_error = this.checkFormValues()
        if (!form_error) {
            this.doSave(false, true)
        }
    }

    handleDelete = (e) => {
        if (localStorage.getItem('aawt')) {
            if (window.confirm("Are you sure you want to delete '" + this.state.session_name + "'.\nThis can not be undone")) {
                let formData = new FormData();
                formData.append('action', 'delete-toddler-session');
                formData.append('token', localStorage.getItem('aawt'))
                formData.append('session_id', this.state.session_id);

                fetch(this.state.url, {
                    method: 'POST',
                    headers: new Headers(),
                    body: formData
                }).then((response) => {
                    if (response.status === 200) {
                        return response.json();
                    } else {
                        throw Error();
                    }
                }).then((data) => {
                    if (data.statusCode === 200) {
                        this.props.handleDeletedSession();
                    } else {
                        //todo handle this error
                        throw Error()
                    }
                }).catch((err) => {
                    console.log(err)
                    this.setState({
                        error: "Something went wrong. Please try again later."
                    });
                });
            }
        }
    }

    handleErrorFieldChange = (field) => {
        if (this.state.error !== "" && this.state.error_fields.length !== 0) {
            if (field.target.value !== "") {
                field.target.style.borderColor = "black";
                this.setState({
                    error_fields: this.state.error_fields.filter((error_field) => {
                        return error_field !== field.target.id.replace('form-', '')
                    })
                })
            }
        }
    }

    render() {

        let show_delete;
        let handleSave;
        let handleSaveExit;
        if (this.props.action === "create") {
            show_delete = false
            handleSave = this.handleNewSave;
            handleSaveExit = this.handleNewSaveExit;
        } else {
            show_delete = true;
            handleSave = this.handleSave;
            handleSaveExit = this.handleSaveExit
        }

        return (
            <div className="page-heading-container">
                <h2 className="sub-heading">{this.state.session_name}</h2>
                <ToddlerSessionForm
                    action={this.props.action}
                    id={this.state.session_id}
                    name={this.state.session_name}
                    handleNameChange={this.handleSessionNameChange}
                    date={this.state.session_date}
                    handleDateChange={this.handleSessionDateChange}
                    time={this.state.session_time}
                    handleTimeChange={this.handleSessionTimeChange}
                    end_time={this.state.session_end_time}
                    handleEndTimeChange={this.handleSessionEndTimeChange}
                    price={this.state.session_price}
                    handlePriceChange={this.handleSessionPriceChange}
                    reserved={this.state.session_reserved}
                    handleReservedChange={this.handleSessionReservedChange}
                    max={this.state.session_max}
                    handleMaxChange={this.handleSessionMaxChange}
                    image={this.state.session_image}
                    handleImageChange={this.handleSessionImageChange}
                    booked={this.state.session_booked}
                    handleSave={handleSave}
                    handleSaveExit={handleSaveExit}
                    showDelete={show_delete}
                    handleDelete={this.handleDelete}
                    error={this.state.error}
                    error_fields={this.state.error_fields}
                    handleErrorFieldChange={this.handleErrorFieldChange}
                />
            </div>
        );
    }

}

export default ToddlerSession;
